import { StatusBar } from 'expo-status-bar';
import { StyleSheet, View, Image, Pressable, Platform } from 'react-native';
import { useState, useEffect } from 'react';
import * as ImagePicker from 'expo-image-picker';
import { NavigationContainer, useNavigationContainerRef } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import FontAwesome from "@expo/vector-icons/FontAwesome";
import Ionicons from '@expo/vector-icons/Ionicons';

import Button from './components/shared/Button';
import ImageViewer from './components/ImageViewer';
const LogoImage = require('./assets/images/logo-2.png');
const Stack = createNativeStackNavigator();
import { MenuProvider } from 'react-native-popup-menu';

import HomeScreen from './components/HomeScreen';
import PostScreen from './components/PostScreen';
import DetailsScreen from './components/DetailsScreen';
import CreateAccountScreen from './components/account/CreateAccountScreen';
import CommentScreen from './components/CommentScreen';
import UserSummaryScreen from './components/UserSummaryScreen';
import LocationScreen from './components/LocationScreen';
import ManageBusiness from './components/account/ManageBusiness';
import ApprovalsScreen from './components/account/ApprovalsScreen';

export default function App({ navigation }) {
  const navigationRef = useNavigationContainerRef();

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    // Push a history entry so we can intercept the first back press
    window.history.pushState(null, '', window.location.href);
    const handlePopState = () => {
      // Always re-push so the next back press is also interceptable
      window.history.pushState(null, '', window.location.href);
      if (navigationRef.isReady() && navigationRef.canGoBack()) {
        navigationRef.goBack();
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // const [selectedImage, setSelectedImage] = useState(null);

  // const pickImageAsync = async () => {
  //   let result = await ImagePicker.launchImageLibraryAsync({
  //     allowsEditing: true,
  //     quality: 1,
  //   });

  //   if (!result.canceled) {
  //     setSelectedImage(result.assets[0].uri);
  //   } else {
  //     alert('You did not select any image.');
  //   }
  // };

  function LogoTitle() {
    return (
      <Image
        style={{ width: 198, height: 39 }}
        source={LogoImage}
      />
    );
  }

  return (
    <View style={styles.outerContainer}>
      <View style={styles.appContainer}>
      <MenuProvider>
      <NavigationContainer ref={navigationRef}>
        <Stack.Navigator initialRouteName="HomeScreen">
          <Stack.Screen name="HomeScreen"
            component={HomeScreen}
            options={({ navigation }) => ({
              //title: '',
              //hea
              //headerBackImageSource: <Ionicons name="location-sharp" size={30} color="#25292e" style={styles.buttonIconLeft} />,
              headerTitle: props => <LogoTitle {...props} />,
              headerStyle: {
                backgroundColor: '#CAAA31',
                
                //height: 50,  //only works on web i think
              },
              headerShadowVisible: false,
              headerTitleAlign: 'center',
              headerTintColor: '#fff',
              headerTitleStyle: {
                fontWeight: 'bold',
                color: '#674FE0',
              },
              // headerLeft: () => (
              //   <Pressable
              //     // style={[styles.button, { backgroundColor: "#fff" }]}
              //     onPress={() => navigation.navigate('LocationScreen', { location: location })}
              //   >
              //     <Ionicons name="location-sharp" size={30} color="#25292e" style={styles.buttonIconLeft} />
              //   </Pressable>
              // ),
              // Add a placeholder button without the `onPress` to avoid flicker
              headerRight: () => (
                <Pressable
                  // style={[styles.button, { backgroundColor: "#fff" }]}
                  onPress={() => navigation.navigate('CreateAccountScreen')}
                >
                  <FontAwesome
                    name="user"
                    size={30}
                    color="#25292e"
                    style={styles.buttonIcon}
                  />
                </Pressable>
              ),
            })}
          />
          <Stack.Screen name="PostScreen" 
            component={PostScreen} 
            options={{ 
              title: 'Create a post',
              headerStyle: {
                backgroundColor: '#E0CD67',
              }
             }} />
          <Stack.Screen name="DetailsScreen" 
            component={DetailsScreen} 
            options={{ 
              title: '',
              headerStyle: {
                backgroundColor: '#E0CD67',
              }, 
            }} />
          <Stack.Screen name="CreateAccountScreen"
            component={CreateAccountScreen}
            options={{
              title: 'Edit Profile',
              headerStyle: {
                backgroundColor: '#E0CD67',
              },
            }} />
          <Stack.Screen name="CommentScreen" component={CommentScreen} options={{ title: 'Add comment' }} />
          <Stack.Screen name="UserSummaryScreen"
            component={UserSummaryScreen}
            options={{
              title: 'Information',
            }} />
            <Stack.Screen name="LocationScreen"
            component={LocationScreen}
            options={{
              title: 'Your location',
              headerStyle: {
                backgroundColor: '#E0CD67',
                //height: 50,  //only works on web i think
              },
              //headerTitleAlign: 'center',
              headerTintColor: 'black',
              // headerTitleStyle: {
              //   fontWeight: 'bold',
              //   color: '#674FE0',
              // },
            }} />
          <Stack.Screen name="ManageBusiness"
            component={ManageBusiness}
            options={{
              title: 'Add Your Business',
              headerStyle: {
                backgroundColor: '#E0CD67',
              },
            }} />
          <Stack.Screen name="ApprovalsScreen"
            component={ApprovalsScreen}
            options={{
              title: 'Approvals',
              headerStyle: {
                backgroundColor: '#E0CD67',
              },
            }} />
        </Stack.Navigator>
      </NavigationContainer>
    </MenuProvider>
    </View>
    </View>
  );
}

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    backgroundColor: '#e8e8e8',
    alignItems: 'center',
  },
  appContainer: {
    flex: 1,
    width: '100%',
    alignSelf: 'center',
    ...(Platform.OS === 'web' && { maxWidth: 580 }),
  },
  buttonIconLeft: {
    paddingLeft: 15,
  },
  buttonIcon: {
    paddingRight: 15,
  }
});


